const NO_COVERAGE_SELECTED = 'no coverage selected'

function hasNoCoverageSelectedText(value = '') {
  return String(value).toLowerCase().includes(NO_COVERAGE_SELECTED)
}

function isNotSelectedLevel(level = {}) {
  const amount = String(level.amount ?? '').trim()
  return amount === '0' || amount === '0.00'
}

interface ParseBenefitsOptions {
  suppressNoCoverageSelected?: boolean
}

export const parseBenefits = (products = [], options: ParseBenefitsOptions = {}) => {
  const { suppressNoCoverageSelected = false } = options

  return products
    .flatMap(product => product?.benefits || [])
    .map(benefit => {
      const selected = (benefit?.levels || []).find(level => level?.isSelected)
      if (!selected) return null

      if (suppressNoCoverageSelected) {
        const value = String(selected.description || '').trim()
        if (!value) return null
        if (isNotSelectedLevel(selected)) return null
        if (hasNoCoverageSelectedText(value)) return null
        if (hasNoCoverageSelectedText(benefit?.name)) return null
      }

      return { label: benefit.name, value: selected.description }
    })
    .filter(Boolean)
}
